<template>
  <!--  使用示例-->
  <!--  <swipe-3d-card :autoplay='3000' :duration='500' style='width: 100vw; height: 60vw' :width='"40vw"'>
          <img src='https://img01.yzcdn.cn/vant/apple-1.jpg'>
          <img src='https://img01.yzcdn.cn/vant/apple-2.jpg'>
          <img src='https://img01.yzcdn.cn/vant/apple-3.jpg'>
        </swipe-3d-card>
  -->
  <!--  swipe容器，触摸事件的载体-->
  <div
    ref="container"
    class="swipe-container"
    :style="{
      '--width': isNaN(width) ? width : width + 'px',
      '--height': isNaN(height) ? height : height + 'px',
      '--spacing': isNaN(spacing) ? spacing : spacing + 'px',
      '--scale': scale + deltaScaleLeft + deltaScaleRight,
      '--left': left,
      '--delta-left': deltaLeft,
      '--delta-right': deltaRight,
      '--delta-scale-left': 1 - deltaScaleRight,
      '--delta-scale-right': 1 - deltaScaleLeft,
      '--index-left': indexLeft,
      '--index-right': indexRight,
      '--transition': transition,
    }"
    @touchstart="disabled ? undefined : handleTouchstart"
    @touchmove="disabled ? undefined : handleTouchmove"
  >
    <!--    子级数量不低于3个，效果最好是最少5个-->
    <slot></slot>
  </div>
</template>

<script>
  export default {
    name: 'Swipe3dCard',
    props: {
      // 自动轮播间隔，单位为 ms	number | string
      autoplay: [Number, String],
      // 动画时长，单位为 ms	number | string
      duration: {
        type: Number,
        default: 500,
      },
      // 滑块宽度，单位为px	number | string
      width: {
        type: [Number, String],
        default: '30vw',
      },
      // 滑块高度，单位为px	number | string
      height: {
        type: [Number, String],
        default: '40vw',
      },
      // 后面两排item的间距，单位为px	number | string
      spacing: {
        type: [Number, String],
        default: '5vw',
      },
      // 激活状态item的缩放比例	number
      scale: {
        type: Number,
        default: 1.2,
      },
      disabled: {
        type: Boolean,
        default: false,
      },
    },
    data() {
      return {
        count: 0,
        interval: null,
        timer: null,
        container: null,
        left: 0,
        x: undefined,
        y: undefined,
        offsetLeft: 0,
        deltaLeft: '0px',
        deltaRight: '0px',
        deltaScaleLeft: 0,
        deltaScaleRight: 0,
        indexLeft: 0,
        indexRight: 0,
        target: null,
        transition: '',
      }
    },
    watch: {
      autoplay() {
        clearTimeout(this.timer)
        this.handleChangeAutoplay()
      },
    },
    mounted() {
      this.container = this.$refs.container
      // 定时监听子组件的数量变化
      this.interval = setInterval(this.init, 43)
      // 监听触摸事件
      window.addEventListener('touchend', this.handleTouchend)
    },
    beforeDestroy() {
      // 注销事件
      clearInterval(this.interval)
      window.removeEventListener('touchend', this.handleTouchend)
    },
    methods: {
      handleTouchstart({ targetTouches }) {
        console.log(1111)
        // 条件：单指触控和动画结束
        if (targetTouches.length === 1 && this.transition === '') {
          const [touch] = targetTouches
          this.target = touch.target.closest('.swipe-item-active')
          if (
            Array.prototype.includes.call(this.container.children, this.target)
          ) {
            // 记录触摸开始位置和激活节点的初始位置
            this.x = touch.pageX
            this.y = touch.pageY
            this.offsetLeft = this.target.offsetLeft
          }
        }
      },
      handleTouchmove(event) {
        // 条件：符合触摸开始条件
        if (this.x !== undefined) {
          event.preventDefault()
          event.stopPropagation()
          const [{ pageX, pageY }] = event.targetTouches
          let delta = (pageX - this.x) / 3,
            scaleLeft = 0,
            scaleRight = 0
          // 条件：主要滑动为左右滑动
          if (Math.abs(delta) > Math.abs(pageY - this.y)) {
            let prev = this.target.previousElementSibling
            if (!prev) {
              prev = this.target.parentElement.lastElementChild
            }
            let left = prev.offsetLeft
            if (this.offsetLeft + delta < left) {
              delta = left - this.offsetLeft
            }
            scaleLeft = delta / (prev.offsetLeft - this.offsetLeft)
            scaleLeft *= scaleLeft
            scaleLeft = (1 - this.scale) * scaleLeft
            let next = this.target.nextElementSibling
            if (!next) {
              next = this.target.parentElement.firstElementChild
            }
            left = next.offsetLeft
            if (this.offsetLeft + delta > left) {
              delta = left - this.offsetLeft
            }
            scaleRight = delta / (next.offsetLeft - this.offsetLeft)
            scaleRight *= scaleRight
            scaleRight = (1 - this.scale) * scaleRight
            // 判定是左划还是右滑
            if (delta > 0) {
              this.deltaLeft = `${delta}px`
              this.deltaRight = '0px'
              this.target.parentElement
                .querySelector('.x1')
                ?.classList.remove('x1')
              if (scaleRight * 2 > 1 - this.scale) {
                this.indexLeft = 1
                this.target.classList.remove('x2')
              } else {
                this.indexLeft = 3
                this.target.classList.add('x2')
                // todo
                prev = this.target.previousElementSibling
                if (!prev) {
                  prev = this.target.parentElement.lastElementChild
                }
                prev.classList.add('x1')
              }
              this.indexRight = 0
              this.deltaScaleLeft = 0
              this.deltaScaleRight = scaleRight
            } else {
              this.deltaLeft = '0px'
              this.deltaRight = `${delta}px`
              this.indexLeft = 0
              this.target.parentElement
                .querySelector('.x1')
                ?.classList.remove('x1')
              if (scaleLeft * 2 > 1 - this.scale) {
                this.indexRight = 1
                this.target.classList.remove('x2')
              } else {
                this.indexRight = 2
                this.target.classList.add('x2')
                // todo
                next = this.target.nextElementSibling
                if (!next) {
                  next = this.target.parentElement.firstElementChild
                }
                next.classList.add('x1')
              }
              this.deltaScaleLeft = scaleLeft
              this.deltaScaleRight = 0
            }
          }
        }
      },
      handleTouchend() {
        // 条件：符合触摸开始条件
        if (this.x !== undefined) {
          this.x = undefined
          const scale =
            (0 - this.deltaScaleLeft - this.deltaScaleRight) / (this.scale - 1)
          // 判定大幅滑动还是小幅滑动
          if (scale > 0.05) {
            this.transition = `${(this.duration * 2) / 3}ms`
            let next = this.target.nextElementSibling
            if (!next) {
              next = this.target.parentElement.firstElementChild
            }
            let prev = this.target.previousElementSibling
            if (!prev) {
              prev = this.target.parentElement.lastElementChild
            }
            this.target.parentElement
              .querySelector('.swipe-item-prev-2')
              ?.classList.remove('swipe-item-prev-2')
            this.target.parentElement
              .querySelector('.swipe-item-next-2')
              ?.classList.remove('swipe-item-next-2')
            // 判定是左划还是右滑
            if (this.deltaScaleLeft !== 0) {
              this.next(prev, next)
            } else if (this.deltaScaleRight !== 0) {
              prev.classList.remove('swipe-item-prev')
              prev.classList.add('swipe-item-active')
              this.target.classList.remove('swipe-item-active')
              this.target.classList.add('swipe-item-next')
              next.classList.remove('swipe-item-next')
              if (this.count > 3) {
                next.classList.add('swipe-item-next-2')
              }
              prev = prev.previousElementSibling
              if (!prev) {
                prev = this.target.parentElement.lastElementChild
              }
              prev.classList.add('swipe-item-prev')
              prev = prev.previousElementSibling
              if (!prev) {
                prev = this.target.parentElement.lastElementChild
              }
              prev.classList.add('swipe-item-prev-2')
              if (this.target.previousElementSibling) {
                this.target = this.target.previousElementSibling
              } else {
                this.target = this.container.lastElementChild
              }
            }
            this.deltaLeft = '0px'
            this.deltaRight = '0px'
            this.deltaScaleLeft = 0
            this.deltaScaleRight = 0
            this.indexLeft = 0
            this.indexRight = 0
            setTimeout(() => {
              this.transition = ''
            }, (this.duration * 2) / 3)
            this.target.parentElement
              .querySelector('.x1')
              ?.classList.remove('x1')
            this.target.parentElement
              .querySelector('.x2')
              ?.classList.remove('x2')
          } else {
            this.transition = `${this.duration / 3}ms`
            this.deltaLeft = '0px'
            this.deltaRight = '0px'
            setTimeout(() => {
              this.transition = ''
            }, this.duration / 3)
          }
          clearTimeout(this.timer)
          this.timer = setTimeout(
            this.handleChangeAutoplay,
            parseFloat(this.autoplay),
          )
        }
      },
      next(prev, next) {
        // 左滑的部分操作
        prev.classList.remove('swipe-item-prev')
        prev.classList.remove('swipe-item-active')
        prev.classList.add('swipe-item-prev-2')
        prev = prev.previousElementSibling
        if (!prev) {
          prev = this.target.parentElement.lastElementChild
        }
        prev.classList.remove('swipe-item-prev')
        this.target.classList.remove('swipe-item-active')
        this.target.classList.remove('swipe-item-next')
        this.target.classList.add('swipe-item-prev')
        next.classList.remove('swipe-item-next')
        next.classList.add('swipe-item-active')
        next = next.nextElementSibling
        if (!next) {
          next = this.target.parentElement.firstElementChild
        }
        next.classList.add('swipe-item-next')
        next.classList.remove('swipe-item-next-2')
        next = next.nextElementSibling
        if (!next) {
          next = this.target.parentElement.firstElementChild
        }
        if (this.count > 3) {
          next.classList.add('swipe-item-next-2')
        }
        if (this.target.nextElementSibling) {
          this.target = this.target.nextElementSibling
        } else {
          this.target = this.container.firstElementChild
        }
      },
      init() {
        const count = this.$slots.default.length
        // 定时监听子组件的数量变化
        if (count !== this.count && count > 2) {
          this.count = count
          this.target = this.container.firstElementChild
          this.target.classList.add('swipe-item-active')
          let prev = this.target.previousElementSibling
          if (!prev) {
            prev = this.container.lastElementChild
          }
          prev.classList.add('swipe-item-prev')
          let next = this.target.nextElementSibling
          if (!next) {
            next = this.container.firstElementChild
          }
          next.classList.add('swipe-item-next')
          next = next.nextElementSibling
          if (!next) {
            next = this.container.firstElementChild
          }
          if (this.count > 3) {
            next.classList.add('swipe-item-next-2')
          }
          // 初始化自动轮播
          clearTimeout(this.timer)
          this.timer = setTimeout(
            this.handleChangeAutoplay,
            parseFloat(this.autoplay),
          )
        }
      },
      handleChangeAutoplay() {
        // 条件：有自动轮播和动画结束以及触摸事件没有结束
        if (
          this.autoplay > 0 &&
          this.transition === '' &&
          this.x === undefined
        ) {
          this.timer = setTimeout(
            this.handleChangeAutoplay,
            parseFloat(this.autoplay),
          )
          this.transition = `${this.duration}ms`
          if (!this.target) {
            this.target = this.container.firstElementChild
          }
          let next = this.target.nextElementSibling
          if (!next) {
            next = this.target.parentElement.firstElementChild
          }
          this.target.parentElement.querySelector('.x3')?.classList.remove('x3')
          this.target.classList.add('x3')
          next.classList.add('x2')
          setTimeout(
            target => {
              target.classList.remove('x3')
              next.classList.remove('x2')
            },
            this.duration / 4,
            this.target,
          )
          let prev = this.target.previousElementSibling
          if (!prev) {
            prev = this.target.parentElement.lastElementChild
          }
          this.target.parentElement
            .querySelector('.swipe-item-prev-2')
            ?.classList.remove('swipe-item-prev-2')
          this.target.parentElement
            .querySelector('.swipe-item-next-2')
            ?.classList.remove('swipe-item-next-2')
          this.next(prev, next)
          setTimeout(() => {
            this.transition = ''
          }, this.duration)
        }
      },
    },
  }
</script>

<style scoped lang="scss">
  .swipe-container {
    position: relative;
    user-select: none;

    > * {
      position: absolute !important;
      top: calc(50% - var(--height) / 2);
      left: calc(50% + var(--spacing) / 2);
      width: var(--width);
      height: var(--height);
      transition: var(--transition);
      z-index: 1;
    }

    > ::v-deep .swipe-item {
      &-active {
        z-index: 4;
        transform: scale(var(--scale));
        left: calc(
          50% - var(--width) / 2 + var(--delta-left) + var(--delta-right)
        );
      }

      &-prev {
        transform: scale(var(--delta-scale-left));
        left: calc(50% - var(--spacing) / 2 - var(--width) + var(--delta-left));
        z-index: calc(2 + var(--index-left));
      }

      &-prev-2 {
        left: calc(50% - var(--spacing) / 2 - var(--width));
        z-index: 0;
      }

      &-next {
        transform: scale(var(--delta-scale-right));
        left: calc(50% + var(--spacing) / 2 + var(--delta-right));
        z-index: calc(2 + var(--index-right));
      }

      &-next-2 {
        left: calc(50% + var(--spacing) / 2);
        z-index: 0;
      }
    }
  }
</style>
